<template>
    <div class="box rounded bSecondary shadow-def-md">
        <div class="inner-box">
            <i class="divider" v-bind:class='data.icon' aria-hidden="true"></i>
            <h2 class="tPrimary">{{data.value}}</h2>
            <p class="title tSecondary">{{data.title}}</p>
            <p class="lead tSecondary">{{data.lead}}</p>
        </div>
        <apexchart class="chart" type="area" height="150" :series='series' :options='options'/>
    </div>
</template>

<script>

export default {
    name:'Overview_a',
    props:{
        series:Array,
        options:Object,
        data:Object
    }
}
</script>

<style lang='scss'>
.box{
    position: relative;
    height: 14rem;
    .inner-box{
        text-align: left;
        padding: 1rem 0 0 1rem;
        h2,p{
            margin: 0;
        }
        h2{
            font-family: 'Roboto';
            font-size: 2.2em;
        }
        .title{
            letter-spacing: 0.5px;
            line-height: 1;
            font-size: 1.2em;
        }
        .lead{
            font-size: 0.8em;
        }
        i{
            float: right;
            font-size: 1.5em;
            margin-right: 2rem;
            padding: 1rem;
            border-radius: 50%;
        }
        .fa-users{
            color: #009688;
        }
        .fa-eye{
            color: #ec407a;
        }
    }
    .chart{
        position: absolute;
        bottom: -0.5rem;
        left: 0;
    }
}
</style>
